module.exports = __webpack_public_path__ + "static/media/header.37a304db.svg";